import React from 'react';
import { WeeklyHomeSnapshotResponse } from '../../../api/types';

const pillClassName = (title: string, status: string) => {
    if (title === 'Last Week') {
        if (status === 'On Track') return 'bg-indigo-50 text-indigo-700';
        if (status === 'Watch') return 'bg-amber-50 text-amber-700';
        return 'bg-rose-50 text-rose-700';
    }
    if (title === 'This Week') {
        if (status === 'On Track') return 'bg-emerald-50 text-emerald-700';
        if (status === 'Watch') return 'bg-amber-50 text-amber-700';
        if (status === 'Tight') return 'bg-orange-50 text-orange-700';
        return 'bg-rose-50 text-rose-700';
    }
    return 'bg-rose-50 text-rose-700';
};

function SnapshotCard({
    title,
    status,
    bullets,
    tutorialAnchor,
}: {
    title: string;
    status: string;
    bullets: string[];
    tutorialAnchor?: string;
}) {
    return (
        <div data-tutorial={tutorialAnchor} className="dashboard-card min-h-[164px] bg-white">
            <div className="mb-4 flex items-start justify-between gap-3">
                <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
                <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${pillClassName(title, status)}`}>
                    {status}
                </span>
            </div>
            <ul className="space-y-2.5">
                {bullets.map((bullet, index) => (
                    <li key={`${title}-${index}`} className="flex items-start gap-3 text-sm leading-6 text-gray-800">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                        <span>{bullet}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function WeeklySnapshotCards({
    snapshot,
    isLoading,
}: {
    snapshot?: WeeklyHomeSnapshotResponse;
    isLoading?: boolean;
}) {
    if (isLoading && !snapshot) {
        return (
            <div data-tutorial="home-snapshot" className="mb-8 grid gap-4 md:grid-cols-3">
                {[0, 1, 2].map((index) => (
                    <div key={index} className="dashboard-card min-h-[164px] animate-pulse bg-white">
                        <div className="mb-5 h-6 w-28 rounded bg-gray-100" />
                        <div className="space-y-3">
                            <div className="h-4 w-4/5 rounded bg-gray-100" />
                            <div className="h-4 w-3/4 rounded bg-gray-100" />
                            <div className="h-4 w-2/3 rounded bg-gray-100" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!snapshot) return null;

    return (
        <div data-tutorial="home-snapshot" className="mb-6 grid gap-4 md:grid-cols-3">
            <SnapshotCard title="Last Week" status={snapshot.last_week_status} bullets={snapshot.last_week_bullets} tutorialAnchor="home-snapshot-primary" />
            <SnapshotCard title="This Week" status={snapshot.this_week_status} bullets={snapshot.this_week_bullets} />
            <SnapshotCard title="Key Risks" status={snapshot.key_risks_status} bullets={snapshot.key_risks_bullets} />
        </div>
    );
}
